import React from "react";
import { FileText } from "lucide-react";

/** Page header — same DNA as approve screen (icon tile, navy title, slate subtitle). */
export default function CompanyFormsPageHeader({
  title,
  subtitle,
  icon: Icon = FileText,
  actions = null,
}) {
  return (
    <header className="company-forms-page-header flex w-full flex-row flex-nowrap items-center gap-2.5 border-b border-[#E5ECF5] bg-white px-3 py-2.5 sm:px-4">
      <div className="company-forms-page-header__icon flex h-9 w-9 shrink-0 grow-0 items-center justify-center rounded-lg bg-[#EFF6FF] text-[#007BFF]">
        <Icon size={18} strokeWidth={1.75} aria-hidden />
      </div>
      <div className="company-forms-page-header__text min-w-0 flex-1 text-left">
        <h1 className="company-forms-page-title m-0 text-[15px] font-semibold text-[#14213D]">
          {title}
        </h1>
        {subtitle ? (
          <p className="company-forms-page-subtitle mb-0 mt-0.5 text-[12px] text-[#64748B]">
            {subtitle}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div className="company-forms-page-actions flex shrink-0 flex-nowrap items-center justify-end gap-2">
          {actions}
        </div>
      ) : null}
    </header>
  );
}
